import * as React from 'react';
import _startCase from 'lodash/startCase';
import styled from '@emotion/styled';

const GroupFieldset = styled.fieldset`
  border-radius: 4px;
  width: 100%;
  padding: 4px 8px 4px 16px;
  font-size: 1rem;
  line-height: 1.4375em;
  min-height: 66px;
  margin-top: -10px;
`;

const Legend = styled.legend`
  font-size: 0.75em;
`;
interface IReadOnlyGroup {
  name?: string;
  render?: () => React.ReactNode;
}

function ReadOnlyGroup({ name, render }: IReadOnlyGroup) {
  return (
    <GroupFieldset>
      <Legend>{_startCase(name)}</Legend>
      {render ? render() : null}
    </GroupFieldset>
  );
}

export default ReadOnlyGroup;
